export default __webpack_public_path__ + "static/media/search.1644ba69.svg";